import './bootstrap';
import app, { showToast } from './vue/backoffice';
import KTComponents from "../metronic/core/index";
import KTLayout from "../metronic/app/layouts/demo1.js";

// // Mount Vue app
app.mount('#back-office-app');

// Wait for DOM and Metronic to be ready
document.addEventListener('DOMContentLoaded', () => {
    // Make toast available globally if needed
    window.showToast = showToast;

    KTComponents.init();
    KTLayout.init();
});

// DismissAlert Function
window.dismissAlert = function (alertId) {
    const alert = document.getElementById(alertId);
    if (alert) {
        alert.classList.add('hidden');
    }
}

// Form Submit Button Loading
$('form').on('submit', function(e) {
    e.preventDefault();
    var form = this;

    $('button.submit-form-btn').attr('disabled', true);
    $('button > .indicator-label').addClass('hidden');
    $('button > .indicator-progress').removeClass('hidden');

    form.submit();
});
